import { gql } from "urql";

export const CREATE_CLASSIFIER_EXCLUSION_MUTATION = gql`
  mutation CreateClassifierExclusion($input: ClassifierExclusionCreateInput!) {
    createClassifierExclusion(input: $input) {
      id
    }
  }
`;
